// Experimental Features that can be enabled by the Admins.
export const featureFlags = {
  debug: 'Debug Mode',
  'owner-reveal': 'Owner Reveal',
  'owner-reveal-mock-data': 'Ⓜ️ Owner Reveal Mock Data',
  'report-slideshow': 'Report Slideshow',
  'brands-layer-main-map': 'Brands Layer on Main Map',
  'show-tax-assessor-id': 'Show Tax Assessor ID',
  'owner-search': 'Owner Search',
  'insight-zipped': 'Insight Zipped',
  'parcel-selection-enhancement': 'Parcel Selection Enhancement',
  'map-experimental-styles': 'Map Experimental Styles',
  'tenant-finder-print': '🖨️ Tenant Finder Print',
  'tenants-visits-trends': '📈 Tenants Visits Trends',
  'alternative-pin-icons': 'Alternative Pin Icons',
  'brand-profile': 'Brand Profile',
  'debug-parcel-layer': 'Debug Parcel Layer',
  'atlas-chat': 'Atlas Chat',
}

export type FeatureFlag = keyof typeof featureFlags
export type FeatureFlags = Array<FeatureFlag>
